import React from 'react';

const SharedCard = ({ children, title }) => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow-xl border border-[#961914] transition-all duration-300 hover:shadow-2xl">
      {title && <h2 className="text-2xl font-bold text-black mb-4">{title}</h2>}
      {children}
    </div>
  );
};

export default SharedCard;